import { useMutation } from '@debbie/common/dist/util/hooks.js';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { errorNotification } from '../utils/errors.js';
import EditText from './Icons/EditText.js';
import { Input, Modal } from './index.js';
const EditReferenceId = (props) => {
    const lang = useSelector((s) => s.lang);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [value, setValue] = useState('');
    const toggleModal = () => setEditModalOpen(!editModalOpen);
    useEffect(() => {
        props.value && setValue(props.value);
    }, [props.value]);
    const updateMutation = useMutation(() => props.onUpdate(value), {
        onSuccess: () => {
            setEditModalOpen(false);
        },
        onError: (err) => {
            errorNotification(lang, err, 'update', lang.errorEntities.referenceId);
        },
    });
    const update = () => {
        updateMutation.mutate();
    };
    return (React.createElement(Wrapper, null,
        React.createElement(StyledEditText, { onClick: toggleModal, style: props.style }),
        editModalOpen && (React.createElement(Modal, { onToggle: toggleModal, header: props.placeholder },
            React.createElement(Input, { autofocus: true, placeholder: props.placeholder, value: value, onChange: (e) => {
                    setValue(e.target.value);
                }, onSubmit: update })))));
};
export default EditReferenceId;
const Wrapper = styled.div `
  padding-left: 8px;
  vertical-align: middle;
  display: inline-block;
`;
const StyledEditText = styled(EditText) `
  width: 16px;
  height: 16px;
  cursor: pointer;
`;
//# sourceMappingURL=EditReferenceId.js.map